// src/App.js
import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import { auth } from "./firebase";
import { onAuthStateChanged, signOut } from "firebase/auth";
import LoginPage from "./pages/LoginPage";
import ClassManager from "./pages/ClassManager";
import LessonManager from "./pages/LessonManager";
import AchievementManager from "./pages/AchievementManager"; // EKLENDİ ✅

function App() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, setUser);
    return () => unsubscribe();
  }, []);

  if (!user) {
    return <LoginPage />;
  }

  return (
    <Router>
      <div style={{ display: "flex", height: "100vh" }}>
        {/* Sol Menü */}
        <div style={styles.sidebar}>
          <Link to="/" style={{ ...styles.menuButton, marginBottom: "30px", fontWeight: "bold" }}>
            Ana Sayfa
          </Link>
          <nav style={styles.navLinks}>
            <Link to="/class-manager" style={styles.menuButton}>Sınıf Ekle</Link>
            <Link to="/lesson-manager" style={styles.menuButton}>Ders Ekle</Link>
            <Link to="/achievement-manager" style={styles.menuButton}>Kazanım Ekle</Link> {/* ✅ YENİ */}
            <button onClick={() => signOut(auth)} style={styles.logoutButton}>Çıkış Yap</button>
          </nav>
        </div>

        {/* Ana İçerik */}
        <div style={{ flex: 1, padding: "40px" }}>
          <Routes>
            <Route
              path="/"
              element={
                <div style={styles.homeContainer}>
                  <h1 style={styles.homeTitle}>Ana Sayfa</h1>
                  <p style={styles.welcomeText}>👋 Hoş geldiniz!</p>
                </div>
              }
            />
            <Route path="/class-manager" element={<ClassManager />} />
            <Route path="/lesson-manager" element={<LessonManager />} />
            <Route path="/achievement-manager" element={<AchievementManager />} /> {/* ✅ YENİ */}
          </Routes>
        </div>
      </div>
    </Router>
  );
}

// Modern stiller
const styles = {
  sidebar: {
    width: "240px",
    backgroundColor: "#f0f4f8",
    padding: "20px",
    borderRight: "1px solid #ddd",
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  menuButton: {
    width: "80%",
    padding: "12px 0",
    backgroundColor: "#007bff",
    color: "#fff",
    textDecoration: "none",
    borderRadius: "10px",
    textAlign: "center",
    transition: "all 0.3s",
    boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)"
  },
  logoutButton: {
    width: "80%",
    padding: "12px 0",
    backgroundColor: "#dc3545",
    color: "#fff",
    border: "none",
    borderRadius: "10px",
    cursor: "pointer",
    textAlign: "center",
    transition: "all 0.3s",
    boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)"
  },
  navLinks: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
    width: "100%",
    alignItems: "center"
  },
  homeContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    textAlign: "center"
  },
  homeTitle: {
    fontSize: "36px",
    marginBottom: "20px"
  },
  welcomeText: {
    fontSize: "24px"
  }
};

export default App;
